import React from 'react';
import PropTypes from 'prop-types';
import TagListAction from '../TagListAction';
import Tooltip from '../../Tooltip';
import { classes } from '../TagList.st.css.js';
const ToggleMoreButton = ({ toggleMoreButton, onClick, amountOfHiddenTags, isExpanded, dataHook, size, }) => {
    const { label, tooltipContent, tooltipProps, ...props } = toggleMoreButton(amountOfHiddenTags, isExpanded);
    const button = (React.createElement(TagListAction, { size: size, skin: "standard", priority: "secondary", ...props, dataHook: dataHook, onClick: onClick }, label));
    if (tooltipContent) {
        return (React.createElement(Tooltip, { content: tooltipContent, className: classes.item, ...tooltipProps }, button));
    }
    return button;
};
ToggleMoreButton.displayName = 'ToggleMoreButton';
ToggleMoreButton.propTypes = {
    toggleMoreButton: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    amountOfHiddenTags: PropTypes.number.isRequired,
    isExpanded: PropTypes.bool,
    dataHook: PropTypes.string,
};
export default ToggleMoreButton;
//# sourceMappingURL=ToggleMoreButton.js.map